import { useStateValue } from './order-calculator-context';

export function useBinVolumeGetter() {
  const [state] = useStateValue();
  const { smoothingModel } = state;
  return level => {
    if (!level?.properties) {
      return;
    }
    return smoothingModel !== 'none'
      ? (level.properties.estimatedVolume ?? level.properties.volume)
      : level.properties.volume;
  };
}
